(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 768;

  let toolbar = null;
  let originalTop = 0;
  let initialOriginalTop = 0;
  let ticking = false;
  let spacer = null;
  let scrollPosition = 0;

  function init() {
    toolbar = document.getElementById('searchspring-toolbar');
    if (!toolbar) return;

    // Store the original position - only once at initialization
    updateOriginalTop();
    initialOriginalTop = originalTop;

    // Create spacer to maintain space when toolbar becomes fixed
    spacer = document.createElement('div');
    spacer.className = 'searchspring-toolbar-spacer';
    toolbar.parentNode.insertBefore(spacer, toolbar.nextSibling);

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', handleResize);

    handleScroll();
    waitForElement('#filter-modal', setupModalObserver);
  }

  function updateOriginalTop() {
    const rect = toolbar.getBoundingClientRect();
    originalTop = rect.top + window.pageYOffset;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function handleScroll() {
    ticking = false;

    if (!toolbar || window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar?.classList.remove('is-sticky');
      if (spacer) spacer.style.height = '0px';
      return;
    }

    const scrollTop = window.pageYOffset;
    const isSticky = toolbar.classList.contains('is-sticky');
    const shouldBeSticky = scrollTop > initialOriginalTop + toolbar.offsetHeight;

    if (shouldBeSticky && !isSticky) {
      // Make sticky - set spacer FIRST to prevent jump
      spacer.style.height = toolbar.offsetHeight + 'px';
      // Force browser to apply the spacer height before adding sticky class
      void toolbar.offsetHeight;
      toolbar.classList.add('is-sticky');
    } else if (!shouldBeSticky && isSticky) {
      // Remove sticky - keep spacer until class is removed
      toolbar.classList.remove('is-sticky');
      // Force browser to apply the class removal first
      void toolbar.offsetHeight;
      spacer.style.height = '0px';
    }
  }

  function handleResize() {
    if (!toolbar) return;

    if (!toolbar.classList.contains('is-sticky')) {
      updateOriginalTop();
    } else if (window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar.classList.remove('is-sticky');
      spacer.style.height = '0px';
    } else {
      spacer.style.height = toolbar.offsetHeight + 'px';
    }
  }

  // Filter modal scroll lock - NEW CODE
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) return callback(element);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupModalObserver(filterModal) {
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = filterModal.classList.contains('open');
          const wasOpen = mutation.oldValue?.includes('open');

          if (isOpen && !wasOpen) {
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            Object.assign(document.body.style, {
              position: 'fixed',
              top: `-${scrollPosition}px`,
              width: '100%',
              overflow: 'hidden'
            });
          } else if (wasOpen && !isOpen) {
            Object.assign(document.body.style, { position: '', top: '', width: '', overflow: '' });
            setTimeout(() => {
              const productsSection = document.getElementById('searchspring-content') || toolbar;
              if (productsSection) {
                const header = document.querySelector('.site-header');
                window.scrollTo({
                  top: Math.max(0, productsSection.offsetTop - (header?.offsetHeight || 0) - 20),
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
        }
      });
    }).observe(filterModal, { attributes: true, attributeOldValue: true, attributeFilter: ['class'] });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();